// extracted by mini-css-extract-plugin
module.exports = {"section":"LTXwR","bgDark":"_1gw0D","bg":"wTopP","logos":"_3RTo3","logo":"_18pdc","stickySection":"RgUpL","videoContainer":"_3lY07"};